import { Image } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';

const POWERED_BY_BALANCE_URL =
  'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1772638304/corp-management-ui/balance/PoweredByBalance.png';

export type PoweredByBalanceProps = React.ComponentProps<typeof Image>;

const DEFAULT_POWERED_BY_BALANCE_HEIGHT = '20px';

export function PoweredByBalance({
  height = DEFAULT_POWERED_BY_BALANCE_HEIGHT,
  ...props
}: PoweredByBalanceProps): JSX.Element {
  return (
    <Image
      src={POWERED_BY_BALANCE_URL}
      alt="Powered by Balance"
      height={height}
      {...props}
    />
  );
}
